import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import BadgeIcon from '@mui/icons-material/Badge';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type IdentificationDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const IdentificationDetails = ({
  control,
}: IdentificationDetailsProps) => {
  const { errors } = useFormState({
    control,
  });

  const { general: { organizationName, buildingName, yearBuilt } = {} } =
    useWatch({
      control,
    });

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <BadgeIcon fontSize="inherit" />
            <span>&nbsp;Identification</span>
          </Grid>
        </Typography>
        <Grid container>
          <Typography
            component="span"
            variant={'body2'}
            color={
              errors.general?.organizationName
                ? 'error'
                : isNil(organizationName)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {organizationName ?? 'Organization'}
          </Typography>
          <Typography component="span" variant="body2" color="textSecondary">
            &nbsp;•&nbsp;
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.buildingName
                ? 'error'
                : isNil(buildingName)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {buildingName ?? 'Building Name'}
          </Typography>
          <Typography component="span" variant="body2" color="textSecondary">
            &nbsp;•&nbsp;
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.yearBuilt
                ? 'error'
                : isNil(yearBuilt)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {yearBuilt ?? 'Construction Year'}
          </Typography>
        </Grid>
        <Divider />
      </Stack>
    </Box>
  );
};
